<script setup lang="ts">
	import { ref, computed } from 'vue';
	import {msg} from "../../i18n/Message";
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import AutocompleteInput from './AutocompleteInput.vue';
	import {injectEnv} from "@fd/Environment";

	const props = defineProps({
		user: { type: Number, default: 0 },
		hasPermission: Boolean
	});
	
	const emit = defineEmits(['refresh']);
	
	const env = injectEnv();
	
	const region = ref(0);
	const regionName = ref("");
	const errorMessage = ref("");
	
	const isError = computed(() => {
		return  errorMessage.value !== null && errorMessage.value !== undefined && errorMessage.value.length>0;
	});

	function sendForm(): void {
		let data = {"user":props.user};
		let restApi = "api/regions/"+region.value+"/linkUser";
		
		env.net.fetch(restApi,"PUT", data)
			.then(response => response.json())
			.then(data => {
				if (data.ok) {
					errorMessage.value="";
					emit('refresh');
				}
				else {
					errorMessage.value=data.error;
				}
			})
			.catch((error) => {
				errorMessage.value=error.message;
			});
	}
</script>

<template>
<div v-if="isError" class="errors">
	<span class="perr">{{errorMessage}}</span>
</div>
<table class="form" style="overflow: auto;">
	<tbody class="first-body last-body">
		<tr>
			<td>{{msg("menu.addRegion")}}</td>
			<td>
				<autocomplete-input rest-api="./api/regions/suggest" v-model.number="region" 
					:size="24" :tabindex="10" name="regionName" :value="regionName" :suggest-empty="true"/>
			</td>
			<td>
				<button class="buttonSmall" @click="sendForm" :disabled="!hasPermission" tabindex='60'>{{msg("bas.add")}}</button>
			</td>
		</tr>
	</tbody>
</table>
</template>

<style>
</style>

